import React, { useState, useEffect, useRef } from 'react';
import './BeaconButton.scss';
import { COLORS } from '../../../constants/colors';
import Owl from '../Graphics/Owl';
import Close from '../Icons/Close';
import CTAButton from '../CTA/CTAButton/CTAButton';

/**
 * Renders the HelpScout beacon button trigger
 * @param {boolean} isPDP
 * @param {boolean} isHidden
 * @returns {JSX.Element}
 * @constructor
 */
const BeaconButton = ({ isPDP = false }) => {
  const [open, setOpen] = useState(false);
  const [initialized, setInitialized] = useState(true);

  let openBeacon;
  let closeBeacon;

  useEffect(() => {
    const loader = setInterval(() => {
      if (Beacon) {
        clearInterval(loader);

        openBeacon = () => {
          Beacon('open');
        };

        closeBeacon = () => {
          Beacon('close');
        };

        Beacon('on', 'close', () => setOpen(false));
        Beacon('on', 'ready', () => setInitialized(true));
        Beacon('on', 'open', () => setOpen(true));
      }
    }, 200);
  });

  return (
    <div className={`c-beacon-button ${isPDP ? 'is-pdp' : ''}`}>
      <div className="c-beacon-button__inner">
        <CTAButton
          isButton={true}
          onClick={() => {
            if (!open) {
              setOpen(true);
              openBeacon();
            } else {
              setOpen(false);
              closeBeacon();
            }
          }}
          ariaLabel="Open HelpScout Support"
          type="primary"
          text={
            <>
              <span>Have a Question?</span>
              {open ? <Close color={COLORS.white} /> : <Owl color={COLORS.white} />}
            </>
          }
          additionalClasses={`cta primary-black c-beacon-button__button cta color-white ${
            initialized ? 'is-initialized' : ''
          }`}
        />
      </div>
    </div>
  );
};

export default BeaconButton;
